let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("19uFC"), load("eKqiP")]).then(() => parcelRequire('1ZBVj'));